import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { DataService } from '../../services/data';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, AsyncPipe],
  template: `
<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top shadow">
  <div class="container">
    <a class="navbar-brand fw-bold" routerLink="/">
      <span style="color: #F1B82D;">Rent</span>MU.com
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain" aria-controls="navbarMain" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarMain">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/locations" routerLinkActive="active">Locations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/floors" routerLinkActive="active">Floor Plans</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/apply" routerLinkActive="active">Apply/Contact</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/faq" routerLinkActive="active">Tenant FAQ</a>
        </li>
      </ul>
      <div class="d-flex align-items-center">
        @if (settings$ | async; as settings) {
          <span class="navbar-text me-3 d-none d-lg-inline fw-bold text-white">
            {{ settings.phone }}
          </span>
          <a [href]="settings.youtubeUrl" target="_blank" class="text-warning">
            <i class="fa fa-youtube fa-2x"></i>
          </a>
        }
      </div>
    </div>
  </div>
</nav>
  `,
  styles: `
    .nav-link {
      color: var(--brand-medium, #ced4da) !important;
    }
    .nav-link.active {
      color: #F1B82D !important;
      font-weight: bold;
    }
    .navbar-brand {
      font-size: 1.5rem;
    }
  `,
})
export class Navbar {
  private dataService = inject(DataService);
  settings$ = this.dataService.getSettings();
}
